import React, { Component } from 'react';
import CollectionHero from "./../../components/collectionHero";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import Flodeskform from "./../../components/flodeskForm";
import BannerFadeIn from "./../../components/bannerFadeIn";
import BackButton from './../../alpineComponents/backButton';
import {BlogPosts, BlogCategories} from './../../utils/blog';
import {GetUrlVariable} from './../../utils/constants';
import Footer from './../../components/footer';
import SocialSharingBar from './../../components/socialSharingBar';
import {Helmet} from "react-helmet";
//BlogPosts
import Happiness from './happiness';
import Problems from './problems';
import Myanmarmeal from './myanmarmeal';
import Joyinchaos from './joyinchaos';
import Awakeningwild from './awakeningwild';
import Mastermindset from './mastermindset';
import Travelersmindset from './travelersmindset';
import Challenges from './challenges';
import Workfromhome from './workfromhome';
import Covidcabinfever from './covidcabinfever';
import Infertility from './infertility';
import Publishingplatform from './publishingplatform';
import Relationship from './relationship';
import Busy from './busy';
import Trees from './trees';
import Miscarriage from './miscarriage';
import Calling from './calling';
import Halfway from './halfway';
import Failure from './failure';
import Solitude from './solitude';
import Whywait from './whywait';
import Anger from './anger';
import Donut from './donut';
import Foreboding from './foreboding';
import Cuba from './../cuba';
import Disappointment from './disappointment';
import Boredom from './boredom';
import Naturevibes from './naturevibes';
import Thanksgiving2020 from './thanksgiving2020';
import Covidxmas from './covidxmas';
import Lessons from './lessons';
import Selfcare from './selfcare';
import Openhearted from './openhearted';
import Eightmonths from './eightmonths';
import Futureson from './futureson';
import "./blogDetail.css";
import {Redirect} from "react-router";

export default class BlogDetail extends Component {
  constructor(props) {
      super(props);
      this.state={};
  }
  componentDidMount = () =>{
    this.setupPage()
  }
  componentDidUpdate = () =>{
    let id = GetUrlVariable('id');
    if(id != this.state.id){
      this.setupPage()
    }
  }
  setupPage = () =>{
    let id = GetUrlVariable('id');
    let posts = BlogPosts;
    let post;
    if(id){
      post = BlogPosts.filter((post)=> post.slug == id)
      post = post[0];
    }
    this.setState({
      id:id,
      post:post
    })
  }
  render() {
    if(!this.state.post) return null;
    return (
      <div>
        <Helmet>
          <title>{this.state.post.title}</title>
          <meta name="description" content={this.state.post.description} />
        </Helmet>
        <BackButton />
        <BannerFadeIn>
          <div className="large-padding background-image-fill" style={{backgroundImage:"url("+this.state.post.image+")", paddingTop:"30vh", paddingBottom:"30vh"}}>
            <h6 className="white">{this.state.post.date}</h6>
            <h1 className="white">{this.state.post.title}</h1>
          </div>
        </BannerFadeIn>
        <div className="small-padding" style={{marginTop:"-10%", position:"relative", zIndex:10}}>
          <div className="medium-padding max-width-container white-background shadow blog-detail">
            {this.state.id == "happiness" && <Happiness />}
            {this.state.id == "problems" && <Problems />}
            {this.state.id == "myanmarmeal" && <Myanmarmeal />}
            {this.state.id == "joyinchaos" && <Joyinchaos />}
            {this.state.id == "awakeningwild" && <Awakeningwild />}
            {this.state.id == "mastermindset" && <Mastermindset />}
            {this.state.id == "travelersmindset" && <Travelersmindset />}
            {this.state.id == "challenges" && <Challenges />}
            {this.state.id == "workfromhome" && <Workfromhome />}
            {this.state.id == "covidcabinfever" && <Covidcabinfever />}
            {this.state.id == "infertility" && <Infertility />}
            {this.state.id == "publishingplatform" && <Publishingplatform />}
            {this.state.id == "busy" && <Busy />}
            {this.state.id == "trees" && <Trees />}
            {this.state.id == "relationship" && <Relationship />}
            {this.state.id == "miscarriage" && <Miscarriage />}
            {this.state.id == "calling" && <Calling />}
            {this.state.id == "halfway" && <Halfway />}
            {this.state.id == "failure" && <Failure />}
            {this.state.id == "solitude" && <Solitude />}
            {this.state.id == "whywait" && <Whywait />}
            {this.state.id == "anger" && <Anger />}
            {this.state.id == "donut" && <Donut />}
            {this.state.id == "foreboding" && <Foreboding />}
            {this.state.id == "cuba" && <Redirect to="/cuba" />}
            {this.state.id == "disappointment" && <Disappointment />}
            {this.state.id == "boredom" && <Boredom />}
            {this.state.id == "naturevibes" && <Naturevibes />}
            {this.state.id == "thanksgiving2020" && <Thanksgiving2020 />}
            {this.state.id == "covidxmas" && <Covidxmas />}
            {this.state.id == "lessons" && <Lessons />}
            {this.state.id == "selfcare" && <Selfcare />}
            {this.state.id == "openhearted" && <Openhearted />}
            {this.state.id == "eightmonths" && <Eightmonths />}
            {this.state.id == "futureson" && <Futureson />}
            <SocialSharingBar sticky={window.outerWidth > 800 ? true : false} />
          </div>
        </div>
        <ScrollFadeIn>
          <Flodeskform />
        </ScrollFadeIn>

        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/blogDetail/index.js